import moment from "moment";
import { Period } from "../types/period";

export const getSortedPeriod = (period: Period[]) => {
  const copyPeriod = [...period];
  copyPeriod.sort((a, b) => {
    const dateA = a.date;
    const dateB = b.date;
    if (dateA < dateB) return -1;
    if (dateA > dateB) return 1;
    const startTimeA = a.start_time;
    const startTimeB = b.start_time;
    if (startTimeA < startTimeB) return -1;
    if (startTimeA > startTimeB) return 1;
    const endTimeA = a.end_time;
    const endTimeB = b.end_time;
    if (endTimeA < endTimeB) return -1;
    if (endTimeA > endTimeB) return 1;
    return 0;
  });
  return copyPeriod;
};

export const getTranslatedPeriod = (period: Array<Record<string, string>>) => {
  if (!period) return [];
  return period.map((p: any) => ({
    date: moment(p.date),
    start_time: moment(p.start_time, "hh:mm a"),
    end_time: moment(p.end_time, "hh:mm a"),
  }));
};

export const getStringifiedPeriod = (period: Period[]) => {
  return period
    .filter((p) => p.date && p.start_time && p.end_time)
    .map((p) => ({
      date: p.date.format("YYYY-MM-DD"),
      start_time: p.start_time.format("HH:mm"),
      end_time: p.end_time.format("HH:mm"),
    }));
};

export const getTotalTime = (period: Partial<Period>[]) => {
  let total = 0;
  period.forEach((p: any) => {
    if (p.start_time && p.end_time && p.end_time > p.start_time) {
      total += p.end_time - p.start_time;
    }
  });
  return total / 1000 / 60;
};
